/**
 * Date formats for date-fns (NOT moment.js)
 */
export const ISO_DATE_FORMAT = 'yyyy-MM-dd'; // 2020-01-03
export const MONTH_INIT_DATE_FORMAT = 'MM/dd/yyyy'; // 01-03-2023
export const LONG_MONTH_DATE_FORMAT = 'MMMM'; // January
export const LONG_MONTH_DAY_DATE_FORMAT = 'MMMM d'; // January 3
export const LONG_MONTH_DAY_YEAR_DATE_FORMAT = 'MMMM d, yyyy'; // January 3, 2021
export const LONG_MONTH_DAY_YEAR_DATE_WITH_SUFFIX_FORMAT = 'MMMM do, yyyy'; // January 3rd, 2021
export const LONG_YEAR_DATE_FORMAT = 'yyyy'; // 2022
export const NDS_DATE_FORMAT = 'MMM d, yyyy'; // Jan 3, 2020
// Note: AP = Associated Press
export const AP_SHORT_MONTH_DATE_FORMAT = 'MMM. d, yyyy'; // Jan. 3, 2020 (Only use if month is NOT March, April, May, June, or July)
export const AP_LONG_MONTH_DATE_FORMAT = 'MMMM d, yyyy'; // March 3, 2020 (Only use if month is March, April, May, June, or July)
export const SHORT_MONTH_DATE_FORMAT = 'MMM'; // Jan
export const SHORT_MONTH_DAY_DATE_FORMAT = 'MMM d'; // Jun 1
export const SHORT_MONTH_DOT_DAY_DATE_FORMAT = 'MMM. d'; // Jun. 1
export const SHORT_MONTH_DOT_DAY_YEAR_DATE_FORMAT = 'MMM. d, yyyy'; // Jun. 1, 2021
export const SHORT_MONTH_DAY_ORDINAL_DATE_FORMAT = 'MMM do'; // Jun 1st
export const SHORT_MONTH_DAY_YEAR_DATE_FORMAT = 'MMM d, yyyy'; // Jun 1, 2021
export const SHORT_MONTH_YEAR_DATE_FORMAT = "MMM ''yy"; // Jun '21
export const SHORT_MONTH_FULL_YEAR_DATE_FORMAT = 'MMM yyyy'; // Jun 2021
export const ISO_DATE_WITH_TIME_OFFSET = "yyyy-MM-dd'T'HH:mm:ssxxx"; // 2021-04-09T00:00:00-07:00
// The format that <InputDate> expects as its `value`
export const CURRENCY_INPUT_DATE_VALUE = 'MM / dd / yyyy'; // 03 / 10 / 2024

export const ORDINAL = {
  1: '1st',
  2: '2nd',
  3: '3rd',
  4: '4th',
  5: '5th',
  6: '6th',
  7: '7th',
  8: '8th',
  9: '9th',
  10: '10th',
  11: '11th',
  12: '12th',
  13: '13th',
  14: '14th',
  15: '15th',
  16: '16th',
  17: '17th',
  18: '18th',
  19: '19th',
  20: '20th',
  21: '21st',
  22: '22nd',
  23: '23rd',
  24: '24th',
  25: '25th',
  26: '26th',
  27: '27th',
  28: '28th',
  29: '29th',
  30: '30th',
  31: '31st',
} as const;

export const ORDINALS = Object.values(ORDINAL);
